import { Api } from '@multitec/api-service'

import { apiConn } from './api/connector'

export const BackendAPI = new Api(apiConn)
